import { Linkedin, Github, Mail, MessageCircle } from "lucide-react";
import { NAV_IDS, SOCIALS } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = ({ onNavigate }) => {
    const { t } = useLanguage();
    const links = NAV_IDS.map((id, i) => ({ id, label: t.nav.links[i] }));

    return (
        <footer className="relative border-t border-white/5 py-12" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                    <button
                        onClick={() => onNavigate("#home")}
                        className="font-display font-bold text-lg tracking-tight text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 rounded"
                        data-testid="footer-logo"
                    >
                        OVERLAST<span className="text-cyan-400">.</span>STUDIO
                    </button>

                    <nav aria-label="Footer navigation">
                        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2">
                            {links.map((link) => (
                                <li key={link.id}>
                                    <button
                                        onClick={() => onNavigate(`#${link.id}`)}
                                        className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500 hover:text-cyan-400 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 rounded"
                                        data-testid={`footer-link-${link.id}`}
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="flex items-center gap-3">
                        {[
                            { icon: Linkedin, href: SOCIALS.linkedin, label: "LinkedIn", testid: "footer-linkedin" },
                            { icon: Github, href: SOCIALS.github, label: "GitHub", testid: "footer-github" },
                            { icon: MessageCircle, href: SOCIALS.whatsapp, label: "WhatsApp", testid: "footer-whatsapp" },
                            { icon: Mail, href: `mailto:${SOCIALS.email}`, label: "Email", testid: "footer-email" },
                        ].map((s) => (
                            <a
                                key={s.testid}
                                href={s.href}
                                target={s.href.startsWith("http") ? "_blank" : undefined}
                                rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
                                aria-label={s.label}
                                className="rounded-full border border-white/10 bg-white/[0.02] p-2.5 text-zinc-400 transition-colors duration-300 hover:border-cyan-400/40 hover:text-cyan-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400"
                                data-testid={s.testid}
                            >
                                <s.icon className="h-4 w-4" strokeWidth={1.5} />
                            </a>
                        ))}
                    </div>
                </div>
                <div className="mt-10 border-t border-white/5 pt-6 text-center">
                    <p className="font-mono text-xs text-zinc-600" data-testid="footer-copyright">
                        {t.footer.copyright}
                    </p>
                </div>
            </div>
        </footer>
    );
};
